import HeroBanner from '../components/consteNew/HeroBanner';
import NewPlanCards, { ComparisonProvider } from '../components/consteNew/NewPlanCards';
import ComparisonSection from '../components/consteNew/ComparisonSection';
import BannerSection from '../components/consteNew/BannerSection';
import WhyChooseSection from '../components/consteNew/WhyChooseSection';
import ScrollReveal from '../components/consteNew/ScrollReveal';
import { AppWrapper } from '../components/consteNew/styles/components';
import { useState } from 'react';

function ConsteNew() {
  const [comparisonData, setComparisonData] = useState<any[] | null>(null);

  return (
    <ComparisonProvider value={{ comparisonData, setComparisonData }}>
      <AppWrapper>
        <HeroBanner />
        <ScrollReveal delay={0.2} >
          <NewPlanCards />
        </ScrollReveal>
        <ScrollReveal delay={0.2}>
            <ComparisonSection />
        </ScrollReveal>
        <ScrollReveal delay={0.2}>
          <BannerSection />
        </ScrollReveal>
        <ScrollReveal delay={0.2}>
          <WhyChooseSection />
        </ScrollReveal>
      </AppWrapper>
    </ComparisonProvider>

  );
}

export default ConsteNew;
